module.exports = __webpack_public_path__ + "static/img/partners18.c179d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners18.png
// module id = /ZqA
// module chunks = 9